var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMylogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226 512L241 477.053V305.579L226 286L206.579 211H31.79L0 286C0 410.072 101.928 512 226 512V512Z",
    fill: "#FF6B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 286V338.5C192.863 338.5 166 365.363 166 398.5C166 431.637 192.863 458.5 226 458.5V512C350.072 512 451 410.072 451 286L423.053 271H265.79L226 286Z",
    fill: "#E1E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M451 121V61H391C391 27.909 364.091 0 331 0C297.909 0 271 27.909 271 61H226L211 86.737V258.21L226 286H278.5C278.5 319.137 305.363 346 338.5 346C371.637 346 398.5 319.137 398.5 286H451V241C484.091 241 512 214.091 512 181C512 147.909 484.091 121 451 121V121Z",
    fill: "#FFBE40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226 113.5V61C101.928 61 0 161.928 0 286H53.5C53.5 252.863 80.363 226 113.5 226C146.637 226 173.5 252.863 173.5 286H226V233.5C259.137 233.5 286 206.637 286 173.5C286 140.363 259.137 113.5 226 113.5Z",
    fill: "#59ABFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylogo);
export default __webpack_public_path__ + "static/media/mylogo.fd1a3c73e6b6f039fce31218ca9b0683.svg";
export { ForwardRef as ReactComponent };